export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Aplicaciones',
            'SAMPLE'        : {
                'TITLE': 'Ejemplo',
                'BADGE': '25'
            },
            'SAMPLE2'        : {
                'TITLE': 'Ejemplo2',
                'BADGE': '252'
            }
        }
    }
};
